import React from "react";

const ChartSettingsControl = ({ setting, setSetting }) => {
  const handleUpdate = (key, value) => {
    setSetting((prevSetting) => ({
      ...prevSetting,
      [key]: value,
    }));
  };

  const renderInputField = (key, label, value) => {
    return (
      <div>
        <label className="block text-gray-700 text-sm " htmlFor={key}>
          {label}
        </label>
        <input
          id={key}
          type="text"
          value={value}
          onChange={(e) => handleUpdate(key, e.target.value)}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
    );
  };

  const renderCheckboxField = (key, label) => {
    return (
      <div className="flex items-center mt-4">
        <input
          id={key}
          type="checkbox"
          checked={setting[key]}
          onChange={() => handleUpdate(key, !setting[key])}
          className="mr-2 w-4 h-4 text-blue-500 border-gray-300 rounded"
        />
        <label className="text-gray-700 text-sm font-bold" htmlFor={key}>
          {label}
        </label>
      </div>
    );
  };

  return (
    <div className="bg-custom text-gray-900 m-2 rounded overflow-hidden shadow-lg overflow-visible hide">
      <div className="px-6 py-4">
        <div className="text-xl mb-2 border-b border-black pb-2">
          Label Setting
        </div>
        <div className="space-y-4">
          {renderCheckboxField("xLabel", "X Axis Label")}
          {setting.xLabel &&
            renderInputField(
              "xLabelText",
              "X Axis Label Text",
              setting.xLabelText
            )}

          {renderCheckboxField("yLabel", "Y Axis Label")}
          {setting.yLabel &&
            renderInputField(
              "yLabelText",
              "Y Axis Label Text",
              setting.yLabelText
            )}

          {renderCheckboxField("title", "Chart Title")}
          {setting.title &&
            renderInputField(
              "titleText",
              "Chart Title Text",
              setting.titleText
            )}
        </div>
      </div>
    </div>
  );
};

export default ChartSettingsControl;
